import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const UserConsultationTab = () => {
	const location = useLocation();

	const [activeIndex, setActiveIndex] = useState(() => {
		const path = location.pathname;
		if (path.startsWith("/sign-up")) return 0;
		if (path.startsWith("/user-signup-detail")) return 0;
		if (path.startsWith("/physician-signup")) return 1;
		if (path.startsWith("/physician-signup-detail")) return 1;
		if (path.startsWith("/pharmacy-signup")) return 2;
		if (path.startsWith("/past-consultations-detail")) return 2;
		return -1;
	});


	useEffect(() => {
		const path = location.pathname;
		if (
			path.startsWith("/sign-up") ||
			path.startsWith("/consultation-detail")
		) {
			setActiveIndex(0);
		} else if (
			path.startsWith("/physician-signup") ||
			path.startsWith("/physician-signup-detail")
		) {
			setActiveIndex(1);
		} else if (
			path.startsWith("/pharmacy-signup") ||
			path.startsWith("/past-consultations-detail")
		) {
			setActiveIndex(2);
		} else {
			setActiveIndex(-1);
		}
	}, [location.pathname]);

	const tabs = [
		{ name: "Patient", link: "/sign-up" },
		{ name: "Physician", link: "/physician-signup" },
		{ name: "Pharmacy", link: "/pharmacy-signup" },
	];
	return (
		<div className="topebar-tab">
			<div className="general-nav-tab">
				<ul className="d-flex align-items-center gap-3">
					{tabs.map((tab, index) => (
						<li key={index}>
							<Link
								to={tab.link}
								className={`nav-sidebar d-flex align-items-center justify-content-between text-decoration-none ${
									activeIndex === index ? "active" : ""
								}`}
								onClick={() => setActiveIndex(index)}
							>
								<span className="bg-wrapper1">
									<h5 className="main-heading level-7 mb-0 main-heading-font dark-color">
										{tab.name}
									</h5>
								</span>
							</Link>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default UserConsultationTab;
